import { ChangeEvent, FC, useState } from "react";
import { Button, Drawer, Flex, Input, LegacyForm, Typography } from "@payping/web-components";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Close } from "@payping/icons";
import { ValidPersianName } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { DashboardRoutes } from "@/router";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalLastName: FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = LegacyForm.useForm();
  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const lastNameApi = useAppSelector((state) => state.user.personalInfo?.lastName);

  const [lastName, setLastName] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("lastName")}`}
        size={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <LegacyForm
            onFinish={() =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.fatherName.url,
                fieldName: "lastName",
                fieldValue: lastName,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ lastName: mobileFormEditState.lastName ?? lastNameApi }}
          >
            <LegacyForm.Item
              name="lastName"
              rules={[
                {
                  validator(_, value): Promise<void> {
                    if (ValidPersianName(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("profile.validLastName")));
                  },
                },
                { required: true },
              ]}
            >
              <Input
                value={lastName}
                placeholder={t("mobileEditPersonal.enterField", { fieldName: t("common.lastName") })}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                disabled={isPersonalDisable()}
              />
            </LegacyForm.Item>
          </LegacyForm>

          <Typography.Text type={"secondary"}>
            {t("settings.personal.instructions.firstNameAndLastName")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditPersonalLastName;
